import { GridArgs } from "../../../records/grids/gridArgs";

const currentConfigurationClasses = ["currentConfiguration"];
const pendingConfigurationClasses = ["pendingConfiguration"];

export function machineConfigurationCellClass(
  systemDate: Date,
  currentConfigurationField: string,
  machineConfigurationDateField: string
) {
  return (args: GridArgs) => {
    const currentConfiguration: boolean = args.data[currentConfigurationField];
    const machineDate: Date = args.data[machineConfigurationDateField];

    const pendingConfiguration = machineDate > systemDate;

    return pendingConfiguration
      ? pendingConfigurationClasses
      : currentConfiguration
      ? currentConfigurationClasses
      : [];
  };
}
